import React from 'react';
import { BsPencil } from 'react-icons/bs';
import { MdOutlineCancel } from 'react-icons/md';

const EditableField = ({
  label,
  value,
  editing,
  tempValue,
  onEdit,
  onCancel,
  onChange,
  onSave
}) => {
  return (
    <div className="flex flex-col justify-between gap-2">
      <div className="flex-1">
        <h3 className="mb-2 text-base font-semibold">{label}</h3>
        {editing ? (
          <div className="mt-1">
            <input
              type="text"
              value={tempValue}
              onChange={onChange}
              className="block w-full rounded-md border border-gray-300 py-2 px-3 text-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500"
            />
          </div>
        ) : (
          <div className="flex items-center justify-between">
            <span>{value}</span>
            <div
              className="flex cursor-pointer px-3 py-2 text-blue-600"
              onClick={onEdit}
            >
              <BsPencil />
            </div>
          </div>
        )}
      </div>
      {editing && (
        <div className="flex items-center gap-3">
          <div
            className="flex-1 cursor-pointer rounded-lg"
            onClick={onCancel}
          >
            <div className="flex items-center justify-center gap-2 rounded-lg bg-neutral-200 px-3 py-2 text-gray-600">
              <MdOutlineCancel />
              <span className="text-xs">Cancel</span>
            </div>
          </div>

          <button
            type="button"
            onClick={onSave}
            className="flex flex-1 cursor-pointer items-center justify-center gap-2 rounded-lg bg-neutral-200 px-3 py-2 text-xs text-green-600"
          >
            <div className="flex items-center gap-1">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M17.47 250.9C88.82 328.1 158 397.6 224.5 485.5c72.3-143.8 146.3-288.1 268.4-444.37L460 26.06C356.9 135.4 276.8 238.9 207.2 361.9c-48.4-43.6-126.62-105.3-174.38-137z"></path>
              </svg>
              save
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default EditableField;
